import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage2 from "../assets/backdrop.png";
import PageLoader from "../components/Loader";
import useIsMobile from "../Hooks/useIsMobile";
import { setUserInfo,setPermissions} from "../store/rootReducer";
import { useDispatch } from "react-redux";
const LoginPage = ({ onLogin }) => {
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Basic validation
    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST_URL}/v2/auth/login`,
        {
          username: email,
          password: password,
          entityType: "ops",  
        }
      );

      const token = response.data.token;
 
      if (response.status === 200) {
        setError(""); 
        localStorage.setItem("token", token);
        dispatch(
          setUserInfo({
            name: response.data.name,
            email: response.data.email,
            role: response.data.role,
            _id: response.data._id,
          }),
        );
        const permsRes = await axios.get(
          `${process.env.REACT_APP_API_HOST_URL}/ops/v1/orders/me/permissions`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        dispatch(setPermissions(permsRes.data.permissions));
        onLogin(); 
        setIsLoading(false);
        navigate("/dashboard");
      }
    } catch (error) {
       
      setIsLoading(false);
      console.error("Login failed:", error);
      setError("Invalid email or password. Please try again.");
    }
  };

  return (
    <Paper
      component="main"
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.mode === "dark" ? "#333" : "#f9f9f9",
        backgroundImage: isMobile && `url(${backgroundImage2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 4,
          boxShadow: 5,
          borderRadius: 2,
          width: "90%",
          maxWidth: "400px",
        }}
      >
        <Box
          sx={{
            color: "black",
            backgroundColor: "#dfcffc",
            width: "100%",
            height: "55px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{
              margin: 0,
              lineHeight: 1,
            }}
          >
            Login
          </Typography>
        </Box>

        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <TextField
            label="username"
            type="text"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && (
            <Typography
              variant="body2"
              color="error"
              align="center"
              margin="normal"
            >
              {error}
            </Typography>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                width: "30%",
                marginTop: 2,
              }}
            >
              Login
            </Button>
          </Box>
        </form>
        {isLoading && <PageLoader />}
      </Box>
    </Paper>
  );
};

export default LoginPage;
